<script>
export default {
  props: {
    onParameterGraphClick: {
      type: Function,
      required: true,
    },
  },
}
</script>
